export default __webpack_public_path__ + "static/media/carousel3.13299eb4.png";